// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3xuF_","sendOtp":"AuthorizeToLogin_sendOtp__37SS0"};